<!-- Loader -->
<ng-container *ngIf="isLoading$ | async ; else template">
  <section class="sg-product">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3">
              <div class="sg-img">
                <!-- Tab panes -->
                <div style="border: none !important;" class="tab-content">

                  <ngx-skeleton-loader animation="progress" animation="true" appearance="line" [theme]="theme">
                  </ngx-skeleton-loader>

                </div>

              </div>
            </div>
            <div class="col-md-4" style="border-right: 1px solid #e5e5e5!important;">
              <div class="sg-content">

                <div class="pro-name">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '300px', height: '30px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div class="pro-tag">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '250px', height: '60px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div style="padding-top: 5px;" class="pro-rating">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '150px', height: '20px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div class="colo-siz">

                  <div class="pro-btns">
                    <ngx-skeleton-loader animation="progress" appearance="line"
                                         [theme]="{ margin: '5px 0 0 0px', width: '110px', height: '30px',background: '#f1f1f1'}">
                    </ngx-skeleton-loader>
                  </div>

                </div>

              </div>
            </div>
            <div class="col-md-5">
              <div class="sg-content">

                <div class="pro-tag">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '300px', height: '30px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div style="padding-top: 3px" class="pro-tag">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '250px', height: '20px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

                <div style="padding-top: 3px" class="pro-tag">
                  <ngx-skeleton-loader animation="progress" appearance="line"
                                       [theme]="{ margin: '5px 0 0 0px', width: '240px', height: '20px',background: '#f1f1f1'}">
                  </ngx-skeleton-loader>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</ng-container>
<!-- End Loader -->

<app-related-products></app-related-products>

<ng-template #template>
 <div *ngIf="(isLoadingPushToCart$ | async)" class="progress-bar progress-bar-striped progress-bar-animated"
       style="width:100%; height: 5px;"></div>
  <section class="sg-product">
    <div *ngIf="(data$ | async).data as product;else notFound" class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="row">
            <div class="col-md-4 col-sm-12 col-xs-12">
              <div class="sg-img">

                <div id="{{product.code}}" class="tab-content">

                   <ngx-skeleton-loader [hidden]="product.loaded" animation="progress" appearance="line" [theme]="theme">
                  </ngx-skeleton-loader>

                  <ng-container *ngFor="let img of product.pictures; let index = index;">
                    <div lightbox-group [hidden]="!product.loaded" id="previewImg{{index}}"
                         [ngClass]="index==0 ? 'tab-pane active' : 'tab-pane'"
                         role="tabpanel">

                      <ng-container *ngIf="img.previewUrl.length>0; else withoutUrl">
                        <img style="cursor: pointer !important; width:100%" class="img-fluid pict"
                             [hidden]="!product.loaded"
                             [src]="img.imageUrl" lightbox
                             [fullImage]="{path:product.previewUrl}"
                             (load)="product.loaded=true"
                             backgroundColor="black" closeButtonText="x" alt="product image"/>
                      </ng-container>
                      <ng-template #withoutUrl>
                        <img class="img-fluid"
                             src="assets/xemart/images/notImg.png">
                      </ng-template>

                    </div>
                  </ng-container>

                  <div class="nav d-flex" style="padding: 5px;">

                    <a *ngFor="let img of product.pictures; let index = index;" class="nav-item nav-link mx-1"
                       data-toggle="tab" href="javascript:;" (click)="showActive(index,product.pictures.length)">
                      <img id="itemImg{{index}}" src="{{img.imageUrl}}" alt="">
                    </a>
                  </div>
                </div>

              </div>
              <app-product-dimensions [provider]="product.provider">
              </app-product-dimensions>
            </div>
            <div class="col-md-4 col-sm-12 col-xs-12" style="border-right: 1px solid #e5e5e5!important;">
              <div class="sg-content">

                <div class="pro-name">
                  <h1>{{product.name}}</h1>
                </div>

                <div class="pro-tag">
                  <ul class="list-unstyled list-inline">
                    <li class="list-inline-item">
                      <a
                        routerLink="/market/tiendas-asociadas/{{product.supplierCode}}">{{product.supplierLinkToShow}}</a>
                    </li>
                  </ul>

                  <!-- <p style="padding-top: 5px;" align="justify">
                    {{product.shortText}}
                  </p> -->

                  <p *ngIf="product.summaryText && product.showDescriptionSummary" style="max-width: 550px;"
                     align="justify" class="t-heading pr-md-4">
                    {{product.summaryText}}<span class="show-more cursor-pointer"
                                                 (click)="product.showDescriptionSummary = false"> Ver más</span>
                  </p>
                  <p *ngIf="!product.summaryText || (product.summaryText && !product.showDescriptionSummary)"
                     style="max-width: 550px;padding-right: 20px;" align="justify" class="t-heading">
                    {{product.shortText}}<span class="show-more cursor-pointer" *ngIf="product.summaryText"
                                               (click)="product.showDescriptionSummary = true"> Ver menos</span>
                  </p>


                </div>

                <div *ngIf="product.grossWeightToShow.length>0">
                  <img src="assets/icon_peso minimo.svg" style="width: 20px;margin-bottom: 10px;">
                  <span style="font-weight: bold;font-size: 14px;color: #555;letter-spacing: .2px;">
                    {{product.grossWeightToShow}}
                  </span>
                </div>

                <div *ngIf="product.rating>0" style="padding-top: 5px;" class="pro-rating">
                  <ul title="{{product.rating}}" [innerHtml]="product.rating | start"
                      class="list-unstyled list-inline"></ul>
                </div>

                <div class="pro-price">
                  <ul class="list-unstyled list-inline price">
                    <li class="list-inline-item">{{product.priceToShow}}</li>
                    <li class="list-inline-item">{{product.oldPriceToShow}}</li>
                  </ul>
                </div>

                <div class="colo-siz">
                  <div class="details-actions">
                   <!--  <div class="qty">
                      <button class="qty-btn" (click)="reduceQuantity()">−</button>
                      <input  type="number" class="qty-input" step="1" min="1" max="10" readonly [value]="(quantity$| async)">
                      <button class="qty-btn" (click)="increaseQuantity()">+</button>
                    </div> -->
                    <div class="pro-btns">
                      <a disabled="disabled" href="javascript:void(0)" class="cart" (click)="pushToCart(product)">
                        <span class="it-img">
                          <img src="assets/xemart/images/it-cart.png" alt="">
                        </span>
                        <span class="it-title">
                          Añadir al carrito
                        </span>
                      </a>
                    </div>
                  </div>
                </div>

                <div #targetAttrElement>
                  <app-product-attributes [provider]="product.provider">
                  </app-product-attributes>
                </div>

                <p *ngIf="product.showAvailability && product.availabilityToShow?.value"
                style="margin-top:15px; color:#555;border: 1px solid #e0e5f8;background-color: #e0e5f8;border-radius: 5px;padding: 3px; font-size: 14px;">
               {{product.availabilityToShow.value}}
            </p>

                <div #targetElement>
                  <app-product-shipping >
                  </app-product-shipping>
                </div>

              </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xs-12">
              <div class="sg-content">

                <div style="padding-top: 20px" class="pro-tag">
                  <ng-container *ngIf="(provider$ | async) == 0">
                    <ng-container *ngIf="(location$ | async) as location">
                      <p class="cursor-pointer" (click)="selectLocation()"
                         *ngIf="location.locationType==1 || location.locations.length==0"
                         style="color: #5677fc !important;">
                        <i style="font-size: 16px !important; color: #5677fc !important;" class="fa fa-map-marker"></i>
                        {{product.deliveryPeriodToShow}}
                      </p>
                      <p *ngIf="location.locationType==0 && location.locations.length>0">
                        <i class="fa fa-shopping-bag"></i>
                        {{product.deliveryPeriodToShow}}
                      </p>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="(provider$ | async) == 1 ">
                    <p *ngIf="(selectedContact$ | async) else new_contact" class="cursor-pointer"
                       (click)="selectLocation()" style="color: #5677fc !important;">
                      <i style="font-size: 16px !important; color: #5677fc !important;" class="fa fa-map-marker"></i>
                      {{(selectedContact$ | async)?.locationToShow}}
                    </p>
                    <ng-template #new_contact>
                      <p class="cursor-pointer"
                         (click)="selectLocation()" style="color: #5677fc !important;">
                        <i style="font-size: 16px !important; color: #5677fc !important;" class="fa fa-map-marker"></i>
                        Añadir dirección de entrega
                      </p>
                    </ng-template>
                  </ng-container>
                </div>

                <!--  <div style="padding-left: 10px" *ngIf="product.deliveryTimeToShow">
                   {{product.deliveryTimeToShow}}
                 </div> -->

                <div style="padding-top: 3px" class="pro-tag">
                  <p *ngIf="product.shippingChargeToShow">
                    <i class="fa fa-shopping-basket"></i>
                    {{product.shippingChargeToShow.value}}
                  </p>
                </div>

                <div style="padding-top: 3px" class="pro-tag">
                  <p style="font-weight: 700;font-size: 14px;color: #555;" *ngIf="product.specifications?.length>0"><i
                    style="padding-right:3px;"
                    class="fa fa-file-text-o"></i> Descripción:</p>
                  <div style="padding-left: 10px;" *ngFor="let sp of product.specifications; let index = index;"
                       class="tab-pane fade show active" id="pro-det" role="tabpanel">
                    <p><i style="padding-right:3px;" class="fa fa-check"></i>{{sp}}</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</ng-template>
<ng-template #notFound>
    <div class="noResult">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <i style="font-size: 40px;color: #0c8efe;" class="fa fa-shopping-basket"></i>
            <h5 style="font-style: normal !important">
              Producto no encontrado.
            </h5>
            <h6 style="padding: 5px;">
              No encontramos resultados.
              El producto no existe o esta desactivado.
            </h6>
            <a href="market/productos-compras-cuba-online"
               style="color: #007bff !important;text-decoration: underline !important;">
              Ver productos
            </a>
          </div>
        </div>
      </div>
    </div>
</ng-template>

